import { PharmacyDownloadDialog, PharmacySelect } from './shared/PharmacyUI';
import React, { useState } from 'react';
import { Box, Typography, CircularProgress } from '@mui/material';
import * as XLSX from 'xlsx';
import api from '../services/api';
import { IOS } from './shared/MenuLayout';

const ReportModalRedistribucion = ({ open, onClose, datos, parametros }) => {
  const [cargando, setCargando] = useState(null); // null | 'pdf' | 'excel'

  const descargarPDF = async () => {
    if (cargando) return;
    setCargando('pdf');
    try {
      const response = await api.post('/farmacia/almacen/generar-reporte-redistribucion-pdf', {
        datos: datos,
        parametros: parametros
      }, { responseType: 'blob' });

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `Redistribucion_${new Date().getTime()}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      setTimeout(() => onClose(), 400);
    } catch (error) {
      console.error('Error generando PDF:', error);
      alert('Error al generar el PDF');
    } finally {
      setCargando(null);
    }
  };

  const descargarExcel = () => {
    if (cargando) return;
    setCargando('excel');
    try {
      const datosExcel = datos.map(d => ({
        'CÓDIGO': d.MEDCOD || '',
        'PRODUCTO': d.PRODUCTO || '',
        'DONANTE': d.DONANTE || '',
        'MSD DONANTE': parseFloat(d.MSD_DONANTE || 0).toFixed(2),
        'CPMA DONANTE': parseFloat(d.CPMA_DONANTE || 0).toFixed(2),
        'STOCK DONANTE': parseFloat(d.STOCK_DONANTE || 0).toFixed(2),
        'RECEPTOR': d.RECEPTOR || '',
        'ESTADO RECEPTOR': d.ESTADO_RECEPTOR || '',
        'MSD RECEPTOR': parseFloat(d.MSD_RECEPTOR || 0).toFixed(2),
        'STOCK RECEPTOR': parseFloat(d.STOCK_RECEPTOR || 0).toFixed(2),
        'CPMA RECEPTOR': parseFloat(d.CPMA_RECEPTOR || 0).toFixed(2),
        'EXCESO': parseFloat(d.Exceso || 0).toFixed(2),
        'SUGERIDO TRASPASO': parseFloat(d.SUGERIDO_TRASPASO || 0).toFixed(2)
      }));

      const ws = XLSX.utils.json_to_sheet(datosExcel);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Redistribución');

      ws['!cols'] = [
        { wch: 10 }, { wch: 40 }, { wch: 25 }, { wch: 12 }, { wch: 12 },
        { wch: 12 }, { wch: 25 }, { wch: 15 }, { wch: 12 }, { wch: 12 },
        { wch: 12 }, { wch: 10 }, { wch: 15 }
      ];

      XLSX.writeFile(wb, `Redistribucion_${new Date().getTime()}.xlsx`);
      setTimeout(() => onClose(), 400);
    } catch (error) {
      console.error('Error generando Excel:', error);
      alert('Error al generar el Excel');
    } finally {
      setCargando(null);
    }
  };

  if (!open) return null;

  return <PharmacyDownloadDialog open={open} onClose={onClose} title="Descargar redistribución" total={datos.length} busy={!!cargando} options={[{fmt:'pdf',label:'Descargar PDF',onClick:descargarPDF},{fmt:'excel',label:'Descargar Excel',onClick:descargarExcel}]}></PharmacyDownloadDialog>;
};

export default ReportModalRedistribucion;